/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  loginHeader: { id: 'app.containers.Auth.loginHeader' },
  loginButtonText: { id: 'app.containers.Auth.loginButtonText' },
  facebookButtonText: { id: 'app.containers.Auth.facebookButtonText' },
  googleButtonText: { id: 'app.containers.Auth.googleButtonText' },
  or: { id: 'app.containers.Auth.or' },
  email: { id: 'app.containers.Auth.email' },
  password: { id: 'app.containers.Auth.password' },
  passwordPlaceHolder: { id: 'app.containers.Auth.passwordPlaceHolder' },
  forgotPassword: { id: 'app.containers.Auth.forgotPassword' },
  newUser: { id: 'app.containers.Auth.newUser' },
  createAccountButtonText: {
    id: 'app.containers.Auth.createAccountButtonText',
  },
  resetPassword: { id: 'app.containers.Auth.resetPassword' },
  backToLogin: { id: 'app.containers.Auth.backToLogin' },
  emailNotValid: { id: 'app.containers.Auth.emailNotValid' },
  askToLogin: { id: 'app.containers.Auth.askToLogin' },
  createAccountDivider: { id: 'app.containers.Auth.createAccountDivider' },
  countryText: { id: 'app.containers.Auth.countryText' },
  passwordConfirm: { id: 'app.containers.Auth.passwordConfirm' },
  askForVoucher: { id: 'app.containers.Auth.askForVoucher' },
  voucherPlaceHolder: { id: 'app.containers.Auth.voucherPlaceHolder' },
  selectCountryText: { id: 'app.containers.Auth.selectCountryText' },
  resetPassMessage: { id: 'app.containers.Auth.resetPassMessage' },
  invalidInput: { id: 'app.containers.Auth.invalidInput' },

  header: { id: 'app.containers.HomePage.header' },
  subheader: { id: 'app.containers.HomePage.subheader' },
  h1: { id: 'app.containers.register.h1' },
  p1: { id: 'app.containers.register.p1' },
  h2: { id: 'app.containers.register.h2' },
  p2: { id: 'app.containers.register.p2' },
  h3: { id: 'app.containers.register.h3' },
  p3: { id: 'app.containers.register.p3' },
  h4: { id: 'app.containers.register.h4' },
  p4: { id: 'app.containers.register.p4' },
  get100: { id: 'app.containers.register.get100' },
  optional: { id: 'app.containers.register.optional' },
  phoneNumber: { id: 'app.containers.Account.AddressBookPage.NewAddressModal.phoneNumber' },
});



// WEBPACK FOOTER //
// ./app/containers/Auth/messages.js